export default __webpack_public_path__ + "static/media/Walker's Armbands of the Greensward.ecf31ea9.jpg";